import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import FindPassword from '../../pages/auth/find-password';
import FindId, { FindContent } from '../../pages/auth/find-id';
import Verify from '../join/Verify';
import { resetVerify } from '../../store/verify.slice';
import { ACCOUNT_STATUS_TYPE } from '../../pages/auth/login';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store/rootReducer';

interface IProps {
  verifyType: ACCOUNT_STATUS_TYPE;
  inputIdRef: any;
  setLoginCertificationVisible: any;
  onSetFindModal: any;
  onCancel: () => void;
}


const CertificateModal: FC<IProps> = ( { 
  verifyType,
  inputIdRef,
  setLoginCertificationVisible,
  onSetFindModal,
  onCancel
}) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isFinalStep } = useSelector((state: RootState) => state.find);
  const CERTIFICATE_MODAL_MESSAGE = [
    {
      title: t('auth.findId.title'),
      subTitle: t('auth.findId.text7'),
      subFinalStepTitle: (
        <>
          {t('auth.findId.text5')}<br />
          {t('auth.findId.text6')}
        </>
      )
    },
    {
      title: t('auth.findId.button4'),
      subTitle: t('auth.findPassword.text3'),
      subFinalStepTitle: t('campus.staff.text12')
    }
  ]

  useEffect(()=> {
    dispatch(resetVerify());
  }, [])

  const renderTabContent = () => {
    switch (verifyType) {
      case ACCOUNT_STATUS_TYPE.LOGIN :
        return (
          <Verify
            verifyType={ACCOUNT_STATUS_TYPE.LOGIN}
          />
        )
      case ACCOUNT_STATUS_TYPE.FIND_ID :
        return (
          <FindId
            inputIdRef={inputIdRef}
            setLoginCertificationVisible={setLoginCertificationVisible}
            onSetFindModal={onSetFindModal}
          /> 
        )
      case ACCOUNT_STATUS_TYPE.FIND_PASSWORD :
        return (
          <FindPassword 
            inputIdRef={inputIdRef}
            setLoginCertificationVisible={setLoginCertificationVisible}
            onSetFindModal={onSetFindModal}
          />
        )
    }
  }

  return (
    <div className="content">
      <div className="login-wrap" style={{ height:'100%' }}>
        <div className="login-edge-layer" style={{ height: 'inherit' }}>
          <div className="bx-header">
            <h1 className="title">{CERTIFICATE_MODAL_MESSAGE[verifyType]?.title || ''}</h1>
            <p className="sub-title">
                { isFinalStep 
                    ? CERTIFICATE_MODAL_MESSAGE[verifyType]?.subFinalStepTitle || ''
                    : CERTIFICATE_MODAL_MESSAGE[verifyType]?.subTitle || ''
                }
            </p>
          </div>
          <div className="bx-body">
            { renderTabContent() }
          </div>
          <button
            type="button"
            className="btn-close-modal"
            onClick={onCancel}
          />
        </div>
      </div>
    </div>
  )
}

export default CertificateModal;
